// extracted by mini-css-extract-plugin
module.exports = {"users":"Users_users__34VWU","toggle":"Users_toggle__1ZeJC","list":"Users_list__1owrs"};